import { DoubleListBlock, ListItem as ListItemBlock } from "graphql/generated-types";

const ListItem = ({ item }: { item: ListItemBlock }) => {
	return <li className={item.indentationLevel == 2 ? "ml-4" : ""}>– {item.text}</li>;
};

const ColumnListBlock = ({ block }: { block: DoubleListBlock }) => {
	return (
		<div className="container gap-x-12 sm:grid sm:grid-cols-2 md:grid-cols-3">
			{block.heading && <h3 className="col-span-2 mb-7 text-lg md:col-span-3 lg:text-2xl">{block.heading}</h3>}
			<ul>{block.columnOne?.map((item, index) => <ListItem key={index} item={item as ListItemBlock} />)}</ul>
			<ul>{block.columnTwo?.map((item, index) => <ListItem key={index} item={item as ListItemBlock} />)}</ul>
		</div>
	);
};

export default ColumnListBlock;
